import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function print({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="black"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M11.162 3h1.676c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 011.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V12H7V7.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 011.311-1.311c.378-.193.772-.264 1.167-.296C10.18 3 10.635 3 11.162 3zM9.968 5.024c-.272.022-.373.06-.422.085a1 1 0 00-.437.437c-.025.05-.063.15-.085.422C9 6.25 9 6.623 9 7.2V10h6V7.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 00-.437-.437c-.05-.025-.15-.063-.422-.085C13.75 5 13.377 5 12.8 5h-1.6c-.577 0-.949 0-1.232.024z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        fillRule="evenodd"
        d="M7.161 10h9.678c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 011.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v.678c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 01-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H15v-2h1.8c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 00.437-.437c.025-.05.063-.15.085-.422C19 15.75 19 15.377 19 14.8v-.6c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 00-.437-.437c-.05-.025-.15-.063-.422-.085C17.75 12 17.377 12 16.8 12H7.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 00-.437.437c-.025.05-.063.15-.085.422C5 13.25 5 13.623 5 14.2v.6c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 00.437.437c.05.025.15.063.422.085C6.25 17 6.623 17 7.2 17H9v2H7.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 01-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 013 14.838v-.676c0-.528 0-.982.03-1.357.033-.395.104-.789.297-1.167a3 3 0 011.311-1.311c.378-.193.772-.264 1.167-.296C6.18 10 6.635 10 7.161 10z"
        clipRule="evenodd"
      />
      <path
        stroke="none"
        fillRule="evenodd"
        d="M7 14h10v2.838c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 01-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031h-1.676c-.528 0-.982 0-1.357-.03-.395-.033-.789-.104-1.167-.297a3 3 0 01-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 017 16.838V14zm2 2v.8c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 00.437.437c.05.025.15.063.422.085.283.023.655.024 1.232.024h1.6c.577 0 .949 0 1.232-.024.272-.022.373-.06.422-.085a1 1 0 00.437-.437c.025-.05.063-.15.085-.422C15 17.75 15 17.377 15 16.8V16H9z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default print;
